import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Phone, MapPin } from "lucide-react";
import { FAQS, BUSINESS } from "../data/site";

export default function FAQ() {
    return (
        <>
            <section className="relative overflow-hidden">
                <div className="hero-glow" />
                <div className="relative max-w-4xl mx-auto px-5 lg:px-10 py-20 lg:py-28 text-center">
                    <div className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold">FAQs</div>
                    <h1 className="mt-3 font-display font-extrabold text-slate-900 text-4xl sm:text-5xl tracking-tight leading-[1.05]">
                        Quick answers to common questions.
                    </h1>
                    <p className="mt-6 text-lg text-slate-600 leading-relaxed">
                        Don't see your question? Call or stop by — we're happy to help.
                    </p>
                </div>
            </section>

            <section className="max-w-3xl mx-auto px-5 lg:px-10 pb-16">
                <Accordion type="single" collapsible className="bg-white rounded-3xl border border-slate-100 premium-shadow divide-y divide-slate-100 overflow-hidden" data-testid="faq-accordion">
                    {FAQS.map((f, i) => (
                        <AccordionItem key={i} value={`item-${i}`} className="border-0">
                            <AccordionTrigger className="px-6 py-5 hover:no-underline font-display font-semibold text-slate-900 text-left text-base" data-testid={`faq-trigger-${i}`}>
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="px-6 pb-5 text-slate-600 leading-relaxed">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </section>

            <section className="max-w-3xl mx-auto px-5 lg:px-10 pb-20">
                <div className="rounded-3xl bg-slate-900 text-white p-8 flex flex-col sm:flex-row gap-4 items-center justify-between">
                    <div>
                        <div className="font-display font-bold text-xl">Still have questions?</div>
                        <div className="text-white/70 text-sm mt-1">Talk to a real human in seconds.</div>
                    </div>
                    <div className="flex gap-3">
                        <a href={`tel:${BUSINESS.phoneRaw}`} className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-white text-slate-900 font-semibold hover:bg-slate-100 transition">
                            <Phone className="w-4 h-4" /> Call
                        </a>
                        <a href={BUSINESS.mapsDirections} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-white/10 border border-white/20 text-white font-semibold hover:bg-white/20 transition">
                            <MapPin className="w-4 h-4" /> Visit
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
}
